const firebaseConfig = {
    apiKey: "AIzaSyAE0tN1ESifoFHY43nowKmOS3S7Lng7Wvw",
    authDomain: "crypto-vortex-bc013.firebaseapp.com",
    projectId: "crypto-vortex-bc013",
    storageBucket: "crypto-vortex-bc013.appspot.com",
    messagingSenderId: "394588576894",
    appId: "1:394588576894:web:6066a0ebf07e47892dcc2f"
  };

  export default firebaseConfig;